import { listGlossaryTermsAlphabet } from '../../request/backendApi/glossary/getGlossaryTermsAlphabet';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';

export const getGlossaryAlphabetAtom = RuntimeClientAtom.atom(listGlossaryTermsAlphabet).pipe(
  Atom.keepAlive
);
